import { render, staticRenderFns } from "./ImagesDownloadCard.vue?vue&type=template&id=7b4fb5de&scoped=true&"
import script from "./ImagesDownloadCard.vue?vue&type=script&lang=js&"
export * from "./ImagesDownloadCard.vue?vue&type=script&lang=js&"
import style0 from "./ImagesDownloadCard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImagesDownloadCard.vue?vue&type=style&index=1&id=7b4fb5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4fb5de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
